export var grid = function grid(count, gap, fill) {
  return "\n  display: grid;\n  grid-template-columns: repeat(".concat(count, ", 1fr);\n  gap: ").concat(gap ? gap : "", ";\n  column-fill: ").concat(fill ? fill : "", ";");
};
export var columns = function columns(count, gap, fill) {
  return "\n  display: block;\n  column-count: ".concat(count, ";\n  column-gap: ").concat(gap, ";\n  column-fill: ").concat(fill ? fill : "", ";\n  break-inside: avoid;");
};
export var flex = function flex(direction, justify, _flex, wrap) {
  return "\n  display: flex;\n  flex-direction: ".concat(direction || "", ";\n  justify-content: ").concat(justify || "", ";\n  flex: ").concat(_flex || "", ";\n  flex-wrap: ").concat(wrap || "", ";");
};